import $ from 'jquery'
import Base from 'luminate/src/modules/base'
import Init from '../init'

export default Base.extend({
	directive: 'ajax-form',

	events: {

		init: function() {
			const siteUrl = $('.header_logo > a').attr('href')
			const $element = $(this.$element)
			const $form = $element.find('form')
			const $thankYou = $element.find('.form_thankyou')

			$form.submit(function(e) {
				e.preventDefault()

				const $thisForm = $(this)
				const data = $thisForm.serialize()

				const $button = $thisForm.find('button[type=submit]')
				const buttonContents = $button.html()
				$button.attr('disabled', true)
				$button.html('<span class="h6">Sending...</h6>')

				$.ajax({
					type: 'post',
					url: '',
					data: data,
					success: function(r) {
						if (r.success) {
							$form.addClass('+hidden')
							$thankYou.removeClass('+hidden')
						} else {
							$button.html(buttonContents)
						}
					}
				})
			})
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/modules/ajax-form.js